export default {
    recipes: {
        'chocolate-fudge-cake': {
            id: 'chocolate-fudge-cake',
            urlId: 'chocolate-fudge-cake',
            origDate: '1/2/2018',
            name: 'Chocolate Fudge Cake',
            prepTime: 10,
            cookTime: 60,
            servings: 12,
            image: '',
            sectionIds: [0, 1],
            details: [],
        },
    },

    sections: {
        '0': {
            id: 0,
            ingredientTitle: '',
            directionTitle: '',
            ingredients: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            directions: [0, 1, 2, 3, 4, 5, 6, 7],
            sectionNote: '',
        },
        '1': {
            id: 1,
            ingredientTitle: 'Ganache',
            directionTitle: 'Ganache',
            ingredients: [11, 12],
            directions: [8, 9, 10],
            sectionNote: '',
        },
    },

    ingredients: {
        '0': {
            id: 0,
            amount: '125g / 4 oz',
            name: 'dark chocolate chips',
            note: 'something something blah blah',
        },
        '1': {
            id: 1,
            amount: '100g / 7 tbsp',
            name: 'butter salted',
            note: '',
        },
        '2': {
            id: 2,
            amount: '1 1/4 cups / 275g',
            name: 'white sugar, caster/superfine best',
            note: 'note #2',
        },
        '3': {
            id: 3,
            amount: '1/4 cup / 65 ml',
            name: 'oil (vegetable, canola)',
            note: '',
        },
        '4': { id: 4, amount: '1 tsp', name: 'vanilla extract', note: '' },
        '5': {
            id: 5,
            amount: '2',
            name: 'eggs, at room temperature',
            note: '',
        },
        '6': {
            id: 6,
            amount: '1/4 cup / 17g',
            name: 'cocoa powder',
            note: 'note #3',
        },
        '7': {
            id: 7,
            amount: '1 cup /150g',
            name: 'flour, plain/all purpose',
            note: 'note #4',
        },
        '8': { id: 8, amount: '1 tsp', name: 'baking powder', note: '' },
        '9': {
            id: 9,
            amount: '1 cup / 250ml',
            name: 'boiling hot water',
            note: '',
        },
        '10': {
            id: 10,
            amount: '1 tbsp',
            name: 'coffee granules, optional',
            note: 'note #5',
        },
        '11': {
            id: 11,
            amount: '1 cup / 250 ml heavy',
            name: 'heavy cream',
            note: '30%+ fat',
        },
        '12': {
            id: 12,
            amount: '250 g / 8 oz',
            name: 'dark chocolate chips',
            note: 'note 1',
        },
    },

    directions: {
        '0': {
            id: 0,
            direction:
				'Preheat oven to 150C/300F (standard) or 130C/265F (fan). Grease a 22 cm / 9" springform cake pan and line with parchment / baking paper.',
            note: '',
        },
        '1': {
            id: 1,
            direction:
				'Melt butter and chocolate: Place butter and chocolate in a heatproof bowl.Microwave 3 x 30 seconds on high, mix in between, until melted. Mix.',
            note: '',
        },
        '2': {
            id: 2,
            direction:
				'Oil, vanilla & Sugar: Add oil, vanilla and sugar, mix to combine(this brings down batter temp).',
            note: '',
        },
        '3': {
            id: 3,
            direction: 'Eggs: Add eggs and mix until combined.',
            note: '',
        },
        '4': {
            id: 4,
            direction:
				'Dry Ingredients: Sift cocoa, baking powder and flour(and coffee, if using) directly into the bowl.Mix until smooth, batter will be thin.Some small lumps is ok.',
            note: '',
        },
        '5': {
            id: 5,
            direction: 'Hot water: Add hot water. Mix until incorporated.',
            note: '',
        },
        '6': {
            id: 6,
            direction:
				'Bake: Pour into the cake tin and bake for 1 hour or until a skewer inserted into the centre comes out moist but clean.Check at 50 minutes.The surface will crack(sometimes badly!) but sill subside when it cools and gets covered with frosting so don&rsquo;t stress!',
            note: '',
        },
        '7': {
            id: 7,
            direction:
				'Cool: Remove sides from the cake pan and transfer to a cooling rack to cool. Cool completely before carefully handling to remove base(Note7).',
            note: '',
        },
        '8': {
            id: 8,
            direction:
				'Place chocolate and cream in a heatproof bowl. Microwave 3 x 30 seconds, mixing in between, until chocolate melts. DO NOT let cream come to boil.',
            note: '',
        },
        '9': {
            id: 9,
            direction:
				'Stir chocolate until smooth.Refrigerate for 1 to 2 hours or until thickened to a spreadable consistency like peanut butter.',
            note: '',
        },
        '10': {
            id: 10,
            direction:
				'Spread over the cake - tops and sides.Use a teaspoon in a swirling motion to achieve the textured surface you see in the photos.',
            note: '',
        },
    },
}
